import { useSelector } from 'react-redux';
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';
import { useFetchPosProfileDetails } from '@/services/hooks';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetcher = ({ queryKey }: any) => {
  const url = queryKey[1];
  const userId = queryKey[2];
  const restaurant = queryKey[3];
  const response = axios
    .get(
      `https://${url}/api/method/oyasync_integrations.oyasync_integrations.doctype.restaurant_table_group.restaurant_table_group.get_table_groups?restaurant=${restaurant}&user_id=${userId}`,
      {
        withCredentials: true,
      },
    )
    .then((data) => data.data?.message)
    .catch((error) => error.response.message);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useFetchTableGroups = (userId: string) => {
  const { url } = useSelector(selectAuth);
  const { data } = useFetchPosProfileDetails();

  const restaurant = data?.restaurant;

  return useQuery(['table-groups', url, userId, restaurant], fetcher, {
    enabled: Boolean(userId && data),
  });
};
